<template>
  <div class="teachingexper">
    <div class="exper">
      <div class="expertop">
        <div>教官统计</div>
      </div>
      <div v-for="(item,index) in experData" :key="index" class="classexper classexperNew">
        <!-- <div v-if="index<5">
          <div>
            <img
              style="width:60px;height:80px"
              :src="item.photo"
              alt
              @click="teacherBlogList(item.id)"
            />
          </div>
          <div>
            <div style="font-size:16px;width:190px;">{{item.name}}</div>
            <div style="display:flex;width:190px">
              <div class="gilit">
                <img src="@/assets/icon/博客园.svg" style="width:20px;height:20px;" alt />
                <div style="margin-left:5px">{{item.cnt}}</div>
              </div>
              <div class="gilit" style="margin-left:20px">
                <img src="@/assets/videoimg/give.svg" style="width:20px;height:20px;" alt />
                <div style="margin-left:5px">{{item.assist}}</div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="blogLine">
          <!-- <div :class="[{'oneLable':index === 0},{'twoLable':index === 1},{'threeLable':index === 2}]">{{ index + 1 }}</div> -->
          <div>
            <img :src="item.imgSrc" alt="">
          </div>
          <div :title="item.name">{{ item.name }}</div>
          <div><span style="color: #409EFF;">{{ item.cnt }}</span> 个</div>
        </div>
      </div>
      <div v-if="experData.length === 0" class="noDataBox">
        <span>暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as teacher from '@/api/teacher/teacherInfo.js';
import {
  GetTearcherTj
} from '@/api/clientshome/index.js';
export default {
  data() {
    return {
      experData: '',
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // teacher.TeacherGetBlogCount({ top: 10 }).then((res) => {
      //   this.experData = res.result;
      // });
      GetTearcherTj().then(res=>{
        if(res.code == 200){
          let row = res.result;
          this.experData = [
            {
              imgSrc: require('@/assets/newIndex/u30723.png'),
              name: '部级教官',
              cnt: row.buji,
            },
            {
              imgSrc: require('@/assets/newIndex/u30718.png'),
              name: '省级教官',
              cnt: row.shengji,
            },
            {
              imgSrc: require('@/assets/newIndex/u31110.png'),
              name: '州市级教官',
              cnt: row.dishiji,
            },
            {
              imgSrc: require('@/assets/newIndex/u30727.png'),
              name: '区县教官',
              cnt: row.quxianji,
            }
          ]
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.teachingexper {
  width: 100%;
  min-height: 280px;
  box-sizing: border-box;
  padding: 19px 15px 0px 15px;
}
/* 标题栏 */
.expertop {
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: #4D515A;
  margin-bottom: 20px;
}

.classexperNew{
  .blogLine{
    display: flex;
    align-items: center;
    padding-bottom: 15px;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
    &>div:nth-child(1){
      flex-shrink: 0;
      min-width: 18px;
      height: 18px;
      background-color: transparent;
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      color: #768297;
      border-radius: 3px;
      margin-right: 7px;
      img{
        width: 20px;
        height: 20px;
      }
    }

    .oneLable{
      background-color: #FFE8E3 !important;
      color: #FF7070 !important;
    }
    .twoLable{
      background-color: #FFEDD2 !important;
      color: #FF9255 !important;
    }
    .threeLable{
      background-color: #FFF4CC !important;
      color: #F4AD00 !important;
    }

    &>div:nth-child(2){
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 16px;
      font-weight: 400;
      line-height: 21px;
      color: #31303F;
      

      // &:hover{
      //   cursor: pointer;
      //   color: #1492ff !important;
      // }
    }
    &>div:nth-child(3){
      flex-shrink: 0;
      margin-left: 10px;
      font-size: 400;
      font-size: 14px;
      line-height: 18px;
      color: #7D899D;
    }
  }
}

.noDataBox{
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #7D899D;
  font-size: 16px;
}

/* .classexper {
  color: #555555;
  height: 90px;
  line-height: 40px;
  margin-top: 5px;
}
.classexper > div {
  display: flex;
}
.classexper > div > div {
  margin-left: 20px;
} */
.gilit {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #888;
}
</style>